import { ApolloClient, NormalizedCacheObject } from '@apollo/client'
import { eqIgnoreCase } from '@arcxmoney/arcx-core'
import { poll } from '@arcxmoney/arcx-react'
import { useEffect, useState } from 'react'
import { GraphService, Saving } from 'src/services/GraphService'

export const useSavings = (apolloClient: ApolloClient<NormalizedCacheObject>) => {
  const [savings, setSavings] = useState<Saving[]>([])
  useEffect(() => {
    const graphService = new GraphService(apolloClient)
    return poll(async () => {
      const sortedSavings = (await graphService.fetchSavings()).sort()
      setSavings((prevSavings) =>
        JSON.stringify(prevSavings) !== JSON.stringify(sortedSavings) ? sortedSavings : prevSavings,
      )
    }, 5000)
  }, [apolloClient])

  const getSaving = (id: string) => savings.find((synth) => eqIgnoreCase(id, synth.id))
  const getSavingBySymbol = (symbol: string) => savings.find((synth) => symbol === synth.symbol)

  return {
    getSaving,
    getSavingBySymbol,
    savings,
  }
}
